import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from '../store'

// Interface for the tool
interface IToolState {
	showPreview: boolean
}

// Initial state
const initialState: IToolState = {
	showPreview: false
}

// Slice definition
export const toolSlice = createSlice({
	name: 'tool',
	initialState,
	reducers: {
		setShowPreview: (state, action: PayloadAction<boolean>) => {
			state.showPreview = action.payload
		}
	}
})

// Export actions
export const { setShowPreview } = toolSlice.actions

// Export selectors
export const showPreview = (state: RootState) => state.tool.showPreview

// Export the reducer
export default toolSlice.reducer
